import { useContext } from 'react'

import { FormContext } from '../components/Form'
import { FormContextType, DataType } from '../types'

export const useForm = () => useContext( FormContext )